/**
 * @file   src\mobile\components\createWantAd\PropertyDisplay.js
 * @brief  This file is responsible for nice to haves section display
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import DispImg1 from "../../../images/pastoral-view-img.png";
import FenceIcn from "../../../components/Common/FenceIcn";
import Image from "react-image-webp";

const PropertyDisplay = (props) => {
  const { name, imgPath, webPImg, id, isSelected, order, icon } = props;

  return (
    <div
      className={
        isSelected
          ? "property-display mb-3 selected-property"
          : "property-display mb-3"
      }
    >
      <div className="property-img-wrap">
        <FenceIcn icon={icon} />
        {order && (
          <div className="fence-icn-count">
            <span>{order}</span>
          </div>
        )}
        {imgPath ? (
          <Image
            src={require("..//..//../images/" + imgPath)}
            webp={require("..//..//../images/" + webPImg)}
          />
        ) : (
          <img src={DispImg1} />
        )}
      </div>
      <div className="property-img-info">{name}</div>
    </div>
  );
};
export default PropertyDisplay;
